class RegistrationStatus {
  isRegisteredSuccessfully: boolean = false;
  isAttemptedPayment: boolean = false;
}

export { RegistrationStatus };
export default new RegistrationStatus();
